// @flow

import * as React from 'react';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';
import {InlineCode} from '../../core/InlineCode/InlineCode';

type SupportedTaxIdTableEntryType = {|
  countryName: string,
  externalType: string,
  description: string,
  placeholder: string,
|};

type SupportedTaxIdTableProps = {|
  entries: Array<SupportedTaxIdTableEntryType>,
  children?: React.Node,
|};

export const SupportedTaxIdTable = ({entries}: SupportedTaxIdTableProps) => {
  if (!entries) {
    return null;
  }

  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>Country</TableHeaderCell>
          <TableHeaderCell>Enum</TableHeaderCell>
          <TableHeaderCell>Description</TableHeaderCell>
          <TableHeaderCell>Example</TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr>
            <TableCell>{entry.countryName}</TableCell>
            <TableCell>
              <InlineCode>{entry.externalType}</InlineCode>
            </TableCell>
            <TableCell>{entry.description}</TableCell>
            <TableCell>
              <em>{entry.placeholder}</em>
            </TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
